
define('text!presentation/loginNotifications/views/balancePaid.html',[],function () { return '<div class="balance-paid">\n    <span class="balance-paid__message"\n          data-bind="i18n: balancePaidMessage">\n    </span>\n</div>';});

